export default {
  TOKEN: "pad_token",
  LIST_REFRESH: "pad_list_refresh"
};